import { Controller } from "@hotwired/stimulus"

// One-time disclosure that the site uses essential cookies (session + CSRF
// only — no analytics or advertising cookies are set). Dismissal is stored
// in localStorage so the banner doesn't reappear on subsequent visits.
//
// We versioned the storage key (`v1`) so a future material change to our
// cookie practices can re-show the banner by bumping the version.
export default class extends Controller {
  static values = {
    storageKey: { type: String, default: "nestsera_cookie_acknowledged_v1" }
  }

  connect() {
    if (this.alreadyAcknowledged()) {
      this.element.remove()
      return
    }
    // The banner is rendered hidden by default to avoid layout-flash before
    // we've checked storage. Reveal once we know it should be shown.
    this.element.classList.remove("hidden")
  }

  acknowledge() {
    try {
      localStorage.setItem(this.storageKeyValue, new Date().toISOString())
    } catch (_e) {
      // localStorage can fail in private mode — silently ignore; banner
      // will reappear next visit, which is acceptable.
    }
    this.element.remove()
  }

  alreadyAcknowledged() {
    try {
      return localStorage.getItem(this.storageKeyValue) !== null
    } catch (_e) {
      return false
    }
  }
}
